import React from 'react'

function Freq() {
  return (
                                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g>
<rect x="2" y="1" width="40" height="40" rx="16" fill="white"/>
<path d="M14 14H20M20 14C20 15.1046 20.8954 16 22 16C23.1046 16 24 15.1046 24 14M20 14C20 12.8954 20.8954 12 22 12C23.1046 12 24 12.8954 24 14M24 14H30M14 21H26M26 21C26 22.1046 26.8954 23 28 23C29.1046 23 30 22.1046 30 21C30 19.8954 29.1046 19 28 19C26.8954 19 26 19.8954 26 21ZM18 28H30M18 28C18 26.8954 17.1046 26 16 26C14.8954 26 14 26.8954 14 28C14 29.1046 14.8954 30 16 30C17.1046 30 18 29.1046 18 28Z" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
</g>
<defs>
<filter id="filter0_dd_411_28325" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.356863 0 0 0 0 0.407843 0 0 0 0 0.443137 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_411_28325"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.101961 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_411_28325" result="effect2_dropShadow_411_28325"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_411_28325" result="shape"/>
</filter>
</defs>
</svg>
  )
}

export default Freq